"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EkycUtils = /** @class */ (function () {
    function EkycUtils() {
    }
    /**
     * @returns {string}
     */
    EkycUtils.insertTabletImportantMatterSentence = function () {
        var tabletSentence = "\u30BF\u30D6\u30EC\u30C3\u30C8\u30EC\u30F3\u30BF\u30EB\u306B\u3064\u3044\u3066\u306E\u91CD\u8981\u4E8B\u9805\u306F\u4EE5\u4E0B\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002\nhttps://rehab.cloud/spguide/";
        return tabletSentence;
    };
    return EkycUtils;
}());
exports.default = EkycUtils;
;



//////////////////
// WEBPACK FOOTER
// ./common/src/constrains/ekyc/ekyc_utils.ts
// module id = +jlt
// module chunks = 1